module.exports = __webpack_public_path__ + "assets/checked-1ff36e.svg";